import type { Lot } from "@stockline/shared/types/inventory/lot"
import type { OfflineResourceConfig } from "../../../types"
import { LOT_TABLE } from "./db"

export const lotConfig: OfflineResourceConfig<Lot> = {
  name: "lots",
  syncDisabled: false,
  endpoints: {
    full: "/api/v2/lots",
    delta: "/api/v2/lots/changes",
    push: "/api/v2/lots/changes",
  },
  tableName: LOT_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
